var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyTrade = function SvgCopyTrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.136 8.796a.65.65 0 0 0-.653-.652H5.367a.652.652 0 1 0 0 1.305h2.116c.36 0 .653-.292.653-.653M10.46 10.551a.653.653 0 0 1 0 1.305H5.366a.652.652 0 1 1 0-1.305z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.15 6.033a3.95 3.95 0 0 1 3.95-3.95h4.66c.787 0 1.52.23 2.136.627l3.131 1.211a3.27 3.27 0 0 1 1.763 4.473l-3.27 6.749-.002-.002a4 4 0 0 1-3.809 2.776H3.89a1.74 1.74 0 0 1-1.74-1.74zM6.1 3.4h4.66a2.633 2.633 0 0 1 2.633 2.633v7.884a2.683 2.683 0 0 1-2.684 2.683H3.89a.423.423 0 0 1-.423-.423V6.033A2.633 2.633 0 0 1 6.1 3.4m8.609 8.334 1.896-3.914a1.95 1.95 0 0 0-1.053-2.671l-1.06-.41c.14.405.217.84.217 1.294z",
    clipRule: "evenodd"
  })));
};
export default SvgCopyTrade;